import {Link, LinkProps} from "react-router-dom";
import {BTN_BASE, BTN_SIZES, BTN_VARIANTS, ButtonSize, ButtonVariant} from "../button-const.ts";
import mergeClasses from "../../../utils/merge-classes.ts";

export interface LinkButtonProps extends LinkProps {
    variant?: ButtonVariant;
    size?: ButtonSize;
}

const LinkButton = ({variant = 'primary', size = 'sm', to, className, ...props }: LinkButtonProps) => (
    <Link to={to} className={mergeClasses(BTN_BASE, BTN_VARIANTS[variant], BTN_SIZES[size], className)}>
        {props.children}
    </Link>
)

export default LinkButton;